import { createAction } from 'redux-act'

import {
  ReturnsLoginState,
  ReturnsPickupAddress,
  NormalizedOrderItem,
  SetItemAsReturn,
  Notification,
  OrderItemsSuccess,
  UnsetItemFromReturn,
  ReasonCode,
  Labels,
  SetQuantityForReturnItem,
} from '../types'

export const returnsOrderValidationInProcess = createAction<void>(
  'Returns Order Validation - In Process',
)
export const returnsOrderValidationSuccess = createAction<ReturnsLoginState>(
  'Returns Order Validation - success',
)
export const returnsOrderValidationReset = createAction<void>('Returns Order Validation - reset')
export const returnsOrderValidationFailed = createAction<string>('Returns Order Validation - Fail')
export const setNotification = createAction<Notification>('Set notification')
export const removeNotification = createAction<void>('Remove notification')
export const setReturnsReasonCode =
  createAction<{ itemId: string; returnReasonCode: string }>('Returns Reason')

export const orderItemsLoading = createAction<void>('Order Items - Loading')
export const orderItemsSuccess = createAction<OrderItemsSuccess>('Order Items - success')
export const orderItemsFail = createAction<string>('Order Items - Fail')

export const setItemAsReturn = createAction<{ data: SetItemAsReturn; labels: Labels }>(
  'Set item in Returns list - Return Type',
)
export const unsetItemFromReturn = createAction<{ data: UnsetItemFromReturn; labels: Labels }>(
  'Unset item in Returns list',
)
export const setQuantityForReturnItem = createAction<{
  data: SetQuantityForReturnItem
  labels: Labels
}>('Set quantity for item selected to return')

export const cancelAllItemsFromReturn = createAction<void>('Cancel All items from Returns list')

export const submitReturnsInfoLoading = createAction<void>('Submit returns info - Loading')
export const submitReturnsInfoSuccess = createAction<Object>('Submit returns info - success')
export const submitReturnsInfoFail = createAction<string>('Submit returns info - Fail')

export const cleanReturnsInfo = createAction<void>('Clean returns info')

export const setReturnsPickupAddress = createAction<ReturnsPickupAddress>(
  'Set Returns pickup details - success',
)
export const setSelectedItemForEdit = createAction<NormalizedOrderItem>(
  'Set Selected Items for Edit - Edit Item',
)

export const clearSelectedItemForEdit = createAction<void>('Clean Selected item for edit')
export const setPickupDate = createAction<string>('Set Pickup date')

export const returnsReasonsLoading = createAction<void>('Returns ReasonsList Loading')
export const setReturnsReasons = createAction<[ReasonCode]>('Set Returns ReasonsList')
export const returnsReasonsFail = createAction<string>('Returns ReasonsList - Fail')

export const setIsAuthenticated = createAction<string>('Set Authentication')
export const unsetIsAuthenticated = createAction<void>('Unset Authentication')

export const setLabelsLoaded = createAction<void>('LSL Labels Loaded')

export const setPickupAddressInvalid = createAction<void>('Invalid Pickup Address')
export const setPickupAddressValid = createAction<void>('Valid Pickup Address')
